import { css } from 'styled-components';

const styles = css`
  display: ${(props) => (props.loading ? 'block' : 'none')};
  justify-content: center;
  align-items: center;
  position: absolute;
  transform: translate(-50%, -50%);
  top: 40%;
  left: 40%;
  z-index: 1400;

  &.spinner-container {
    ${(props) => (props.loaderLeft ? `left: 25%` : '')}
  }
  .spc-spinner {
    display: inline-block;
    position: relative;
    width: 5px;
    height: 5px;
  }
  .spc-spinner div {
    position: absolute;
    width: 8px;
    height: 8px;
    animation: tcp-spc-spinner 1.25s infinite;
    animation-timing-function: ease;
    @media ${(props) => props.theme.mediaQuery.medium} {
      width: 14px;
      height: 14px;
    }
    border-radius: 100%;
    background: ${(props) =>
      props.fill === 'black' ? props.theme.colors.BLACK : props.theme.colors.WHITE};
  }
  .spc-spinner div:nth-child(1) {
    left: 0px;
  }
  .spc-spinner div:nth-child(2) {
    animation-delay: 0.25s;
  }

  @keyframes tcp-spc-spinner {
    0% {
      transform: scale(0, 0) translate3d(0, 0, 0);
      opacity: 0%;
    }
    25% {
      transform: scale(1, 1) translate3d(0, 0, 0);
      opacity: 100%;
    }
    50% {
      transform: scale(1, 1) translate3d(40px, 0, 0);
      opacity: 100%;
    }
    75% {
      transform: scale(0.5, 0.5) translate3d(70px, 0, 0);
      opacity: 0%;
    }
    100% {
      transform: scale(0, 0) translate3d(0, 0, 0);
      opacity: 0%;
    }
  }
  ${(props) => (props.inheritedStyles ? props.inheritedStyles : '')};
`;

export default styles;
